import React, { useEffect } from "react";
import {
  FButton,
  FGrid,
  FItem,
  FTypo,
  FDialog,
  FGridItem,
} from "ferrum-design-system";
import { useDispatch } from "react-redux";
import {
  addTokenToMetaMask,
  openTransactionOnExplorer,
} from "../../../../utils/helperFunctions";
import { PATH_DASHBOARD } from "../../../../routes/paths";
import { useHistory } from "react-router-dom";
import * as SwapActions from "../../../../redux/slices/swap";
import Loader from "../../../../assets/gif/animation-loading.gif";
import iconWarning from "../../../../assets/img/icon-warning.png";
import ApprovedIcon from "../../../../assets/img/approvalLogo.png";
import DetailIcon from "../../../../assets/ms-new-images/icons/detail-icon.svg";
import ExportLinkIcon from "../../../../assets/ms-new-images/icons/export-icon.svg";
import QuestionMarkIcon from "../../../../assets/ms-new-images/icons/question-mark-icon.svg";
import GasIcon from "../../../../assets/ms-new-images/icons/gas-icon.svg";
import copyIcon from "../../../../assets/img/icon-copy.svg";
// import underLine from "../../../../assets/img/lines-in-end.svg";
import swapCongratesLogo from "../../../../assets/gif/swap-congrates-logo.gif";
import swappingIcon from "../../../../assets/ms-new-images/icons/swaping-icon.svg";
import xIcon from "../../../../assets/ms-new-images/icons/x-icon.svg";

import {
  SwapAndWithdrawTxStatuses,
  truncateText,
} from "../../../../utils/constants";
import toast from "react-hot-toast";
import ReactTooltip from "react-tooltip";
import Big from "big.js";

const FailedStatuses = [
  "generatorSignatureFailed",
  "validatorSignatureFailed",
  "masterValidationFailed",
  "swapFailed",
  "swapWithdrawFailed",
];

export const SwapAndWithDrawDialog = ({
  slippage,
  showApprovedDialog,
  isTokenQuoteLoading,
  isSwapGasFeeLoading,
  isSwapping,
  isApproving,
  swapSourceAndDestinationFeeInfo,
  swapTransactionHash,
  approvalTransactionHash,
  fromInfo,
  toInfo,
  setShowApprovedDialog,
  withdrawTransactionHash,
  setResetAllStatesOfDialog,
  resetAllStatesOfDialog,
  status,
  error,
  onHide,
  sourceTokenCategorizedInfo,
  destinationTokenCategorizedInfo,
  handleSwapAction,
}: any) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);

  console.log({ swapSourceAndDestinationFeeInfo });
  const onClose = () => {
    setShowApprovedDialog(false);
    setResetAllStatesOfDialog(!resetAllStatesOfDialog);
  };
  console.log("status", status);

  console.log(
    "FailedStatuses.includes(status)",
    FailedStatuses.includes(status)
  );

  console.log({
    isApproving,
    isSwapping,
    status,
    swapTransactionHash,
    approvalTransactionHash,
    error,
  });

  const swapGasPrice = swapSourceAndDestinationFeeInfo?.source?.gasPrice
    ? new Big(Number(swapSourceAndDestinationFeeInfo?.source?.gasPrice))
        .add(Number(swapSourceAndDestinationFeeInfo?.destination?.gasPrice))
        .toFixed()
    : undefined;

  const swapGasPriceInUSD = swapSourceAndDestinationFeeInfo?.source
    ?.gasPriceInUSD
    ? new Big(Number(swapSourceAndDestinationFeeInfo?.source?.gasPriceInUSD))
        .add(
          Number(swapSourceAndDestinationFeeInfo?.destination?.gasPriceInUSD)
        )
        .toFixed()
    : undefined;

  return (
    <div className="full-screen-mobile">
      <FDialog
        size={"medium"}
        variant={"new-popup"}
        title={""}
        show={showApprovedDialog}
        onHide={() => onClose()}
        className="transaction-status text-center"
        showClose={
          status === "approve" ||
          FailedStatuses.includes(status) ||
          error ||
          (status === "" && !isSwapping && !isApproving)
        }
      >
        <div className="full-screen-center">
          {error ? (
            <React.Fragment>
              <img
                className="ml-9"
                src={iconWarning}
                alt={""}
                style={{ width: 100, height: 100 }}
              />
              <FTypo color="white" weight={700} className="f-mt-5 f-pb-3">
                {error}
              </FTypo>
            </React.Fragment>
          ) : isApproving ? (
            <div className="approval-dialog">
              <img
                className="dialogbox-load"
                src={Loader}
                alt={"Loading ..."}
                height={100}
                width={100}
              />
              <h3 className="title f-mt-1">
                Approve {fromInfo?.token?.symbol} Spending
              </h3>
              <div>
                <div className="f-mt-1 d-flex ai ai-center jc jc-center">
                  <img className="logo-size" src={fromInfo?.network?.logo} />{" "}
                  <img className="logo-size" src={fromInfo?.token?.logoURI} />
                  <span className="token-amount">
                    {sourceTokenCategorizedInfo?.sourceAmount}
                  </span>
                  <span className="token-symbol">
                    {fromInfo?.token?.symbol}
                  </span>
                </div>

                <p>Confirm in Your Wallet to Process</p>
              </div>
              <p className="d-flex ai ai-center jc jc-center">
                <span className="f-mr--5" style={{ color: "#88898A" }}>
                  Why is Approval Necessary?{" "}
                </span>
                <a
                  href={
                    "https://help.ferrumnetwork.io/en/articles/8975395-what-is-an-approval-transaction"
                  }
                  target={"_blank"}
                >
                  <img src={ExportLinkIcon} height={15} />
                </a>
              </p>
            </div>
          ) : (isTokenQuoteLoading ||
              isSwapGasFeeLoading ||
              destinationTokenCategorizedInfo?.destinationAmount) &&
            !status ? (
            <div className="quote-dialog">
              {swapGasPrice !== undefined && !isSwapGasFeeLoading ? (
                <>
                  <span className="confirmation-statement">Confirm Swap</span>
                  <>
                    <div>
                      <div>
                        <FTypo size={12} align={"left"}>
                          FROM
                        </FTypo>
                      </div>
                      <div className="d-flex ai-center jc jc-between f-mt--5">
                        <div className="d-flex">
                          <img
                            className="logo-size"
                            src={fromInfo?.network?.logo}
                          />{" "}
                          <img
                            className="logo-size"
                            src={fromInfo?.token?.logoURI}
                          />
                          <FTypo className="token-symbol" size={14}>
                            {fromInfo?.token?.symbol}
                          </FTypo>
                        </div>
                        <div className="d-flex">
                          <FTypo className="token-amount">
                            {sourceTokenCategorizedInfo?.sourceAmount}
                          </FTypo>{" "}
                        </div>
                      </div>
                    </div>
                    <img className="f-mt-1" src={swappingIcon} />
                    <div className="f-mt-1">
                      <div>
                        <FTypo size={12} align={"left"}>
                          MINIMUM RECEIVED
                        </FTypo>
                      </div>
                      <div className="d-flex ai-center jc jc-between f-mt--5">
                        <div className="d-flex">
                          <img
                            className="logo-size"
                            src={toInfo?.network?.logo}
                          />{" "}
                          <img
                            className="logo-size"
                            src={toInfo?.token?.logoURI}
                          />
                          <FTypo className="token-symbol" size={14}>
                            {toInfo?.token?.symbol}
                          </FTypo>
                        </div>
                        <div className="d-flex">
                          <FTypo className="token-amount">
                            {destinationTokenCategorizedInfo?.destinationAmount}
                          </FTypo>{" "}
                        </div>
                      </div>
                    </div>
                    <FButton
                      title={"CONFIRM SWAP"}
                      prefix={
                        isSwapping ? (
                          <img src={Loader} height={12} width={12} />
                        ) : (
                          ""
                        )
                      }
                      disabled={isSwapping}
                      className="confirm-swap-btn f-mt-2"
                      onClick={() => handleSwapAction()}
                    />
                    <div className="f-mt-1 fee-detail">
                      <FGridItem size={[4, 4, 4]}>
                        <div className="d-flex ai ai-center jc jc-center">
                          <ReactTooltip className="small-width-tooltip" />
                          <a
                            className="d-flex ai ai-center jc jc-center"
                            data-tip={`Slippage is currently set to ${slippage}% on source and destination networks`}
                          >
                            <img
                              src={QuestionMarkIcon}
                              height={20}
                              className="f-mr--2"
                            />
                            <FTypo size={11}>
                              Slippage: {Number(slippage) * 2}%
                            </FTypo>
                          </a>
                        </div>
                      </FGridItem>

                      <FGridItem size={[7, 7, 7]}>
                        <div className="d-flex ai ai-center jc jc-center">
                          <ReactTooltip className="small-width-tooltip" />
                          <a
                            className="d-flex ai ai-center jc jc-center"
                            data-tip={`Est. Source Tx Fee: ${Number(
                              swapSourceAndDestinationFeeInfo?.source
                                ?.gasPriceInUSD
                            )?.toFixed(2)}$ & Est. Destination Tx Fee: ${Number(
                              swapSourceAndDestinationFeeInfo?.destination
                                ?.gasPriceInUSD
                            )?.toFixed(2)}$`}
                          >
                            <img
                              src={GasIcon}
                              height={20}
                              className="f-mr--4"
                            />
                            <FTypo size={11}>
                              Est. Gas Fee:{" "}
                              {Number(swapGasPrice ?? "0").toFixed(5)}{" "}
                              {fromInfo?.network?.networkCurrencySymbol}
                            </FTypo>
                          </a>
                        </div>
                      </FGridItem>
                      <FGridItem size={[1, 1, 1]}>
                        <div className="d-flex ai ai-center jc jc-center">
                          <ReactTooltip className="small-width-tooltip" />
                          <a
                            data-tip={`Est. Total Tx Fee: ${Number(
                              swapGasPriceInUSD
                            )?.toFixed(2)}$`}
                          >
                            <img src={DetailIcon} height={15} width={15} />
                          </a>
                        </div>
                      </FGridItem>
                    </div>
                  </>
                </>
              ) : (
                <>
                  <img
                    className="dialogbox-load"
                    src={Loader}
                    alt={""}
                    height={100}
                    width={100}
                  />
                  <h3 className="title f-mt-2">
                    {isSwapGasFeeLoading
                      ? "Fetching Gas Fee"
                      : "Fetching Latest Quote"}
                  </h3>
                  <div className="quote-detail f-mt-2">
                    <div className="quote-item">
                      <div className="f-mt-1 d-flex ai ai-center jc jc-center">
                        <img
                          className="logo-size"
                          src={fromInfo?.network?.logo}
                        />{" "}
                        <img
                          className="logo-size"
                          src={fromInfo?.token?.logoURI}
                        />
                      </div>
                      <div className="token-symbol f-mt--5">
                        {fromInfo?.token?.symbol}
                      </div>
                    </div>
                    <img className="swap-icon f-mt-1" src={swappingIcon} />
                    <div className="quote-item">
                      <div className="f-mt-1 d-flex ai ai-center jc jc-center">
                        <img
                          className="logo-size"
                          src={toInfo?.network?.logo}
                        />{" "}
                        <img
                          className="logo-size"
                          src={toInfo?.token?.logoURI}
                        />
                      </div>
                      <div className="token-symbol f-mt--5">
                        {toInfo?.token?.symbol}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          ) : status !== "swapWithdrawCompleted" &&
            (status === "swapCompleted" ||
              status === "swapWithdrawPending" ||
              swapTransactionHash) &&
            !FailedStatuses.includes(status) &&
            !error ? (
            <React.Fragment>
              <div className="position-dialog-transaction-mobile">
                <FItem align="center">
                  <img
                    src={Loader}
                    style={{ width: 100, height: 100 }}
                    alt=""
                  />
                  <FTypo
                    color="#D9B373"
                    size={18}
                    weight={700}
                    className="f-p-2"
                  >
                    {status === "swapCompleted" ||
                    status === "swapWithdrawPending" ||
                    status === "swapPending"
                      ? "Tx Processing - Please Wait"
                      : SwapAndWithdrawTxStatuses[status]}
                  </FTypo>
                  <FTypo
                    color="white"
                    size={14}
                    weight={700}
                    className="viewOnExplorer d-flex ai ai-center jc jc-center"
                  >
                    <div
                      className=" d-flex ai ai-center jc jc-center cursor-pointer"
                      onClick={() =>
                        window.open(
                          openTransactionOnExplorer(
                            fromInfo?.network?.blockExplorerUrl,
                            swapTransactionHash,
                            fromInfo?.network?.nameInLower
                          ),
                          "_blank"
                        )
                      }
                    >
                      <span className="f-mr--5">View on Explorer</span>
                      <img src={ExportLinkIcon} />
                    </div>
                  </FTypo>
                  <div className="hash-copy-icon">
                    <FTypo
                      color="white"
                      size={12}
                      weight={700}
                      className={"f-mt--5"}
                      truncate={{
                        truncateLength: 10,
                        truncatePosition: "center",
                      }}
                    >
                      TxId: {truncateText(swapTransactionHash, 10, "center")}
                      <img
                        className={"cursor_pointer copyIcon-swap-transaction"}
                        style={{ position: "inherit", marginLeft: "10px" }}
                        src={copyIcon}
                        alt={copyIcon}
                        title="copy"
                        onClick={() => {
                          navigator.clipboard.writeText(swapTransactionHash);
                          toast.success("Copied");
                        }}
                      />
                    </FTypo>
                  </div>
                  <FTypo
                    size={12}
                    weight={700}
                    color={"white"}
                    className={"f-mt-2"}
                  >
                    The transaction was successfully sent!
                  </FTypo>
                  {/* <img src={underLine} alt="" className={"f-mb-3 f-mt-1"} /> */}
                </FItem>
              </div>
            </React.Fragment>
          ) : status === "swapWithdrawCompleted" ? (
            <React.Fragment>
              <div className="position-dialog-congrates-mobile">
                <FItem align="center" className={"f-mt-1"}>
                  <img
                    className=""
                    src={swapCongratesLogo}
                    alt={"swapCongratesLogo"}
                    style={{ width: 126, height: 115 }}
                  />
                  <FTypo
                    color="#D9B373"
                    size={20}
                    weight={700}
                    className="f-mt-1"
                  >
                    Congrats! Swap completed
                  </FTypo>
                  <FTypo
                    color="white"
                    size={14}
                    weight={700}
                    className="f-mt-1 viewOnExplorer cursor-pointer"
                  >
                    <div
                      className=" d-flex ai ai-center jc jc-center"
                      onClick={() =>
                        window.open(
                          openTransactionOnExplorer(
                            toInfo?.network?.blockExplorerUrl,
                            withdrawTransactionHash,
                            toInfo?.network?.nameInLower
                          ),
                          "_blank"
                        )
                      }
                    >
                      <span className="f-mr--5">View on Explorer</span>
                      <img src={ExportLinkIcon} />
                    </div>
                  </FTypo>
                  <div className="hash-copy-icon">
                    <FTypo
                      color="white"
                      size={12}
                      weight={700}
                      className={"f-mt--5 dir-column "}
                      truncate={{
                        truncateLength: 10,
                        truncatePosition: "center",
                      }}
                    >
                      <div>
                        TxId:{" "}
                        {truncateText(withdrawTransactionHash, 10, "center")}
                        <img
                          className={
                            "cursor-pointer copyIcon-swap-approved copyIcon-swap-approved-mobile f-mt--5"
                          }
                          style={{ position: "inherit", marginLeft: "10px" }}
                          src={copyIcon}
                          alt={copyIcon}
                          title="copy"
                          onClick={() => {
                            navigator.clipboard.writeText(
                              withdrawTransactionHash
                            );
                            toast.success("Copied");
                          }}
                        />
                      </div>
                      {/* <div className="x-link-tab d-flex ai ai-center jc jc-center f-mt-1 ">
                        <img src={xIcon} alt="x icon" />{" "}
                        <a
                          className="white-color text-decoration-none custom-font-size-12 "
                          href={`https://twitter.com/intent/post?text=Just%20used%20%23MultiSwap%20by%20%40FerrumNetwork%20to%20swap%20%24${fromInfo?.network?.name}%20on%20%23${fromInfo?.token?.symbol}%20for%20%24${toInfo?.network?.name}%20on%20%23${toInfo?.token.symbol}%20with%20a%20click%20on%20a%20button.%20%0A%0ABlazing%20fast%20swaps%20and%20super%20easy%20to%20use%21%0A%0ATry%20it%20yourself%3A%0Ahttps%3A%2F%2Fmultiswap.ferrumnetwork.io%2F%0A%0A%24FRM%20%23Bridge%20%23CrossChainBridges%20%24RBC%20%23CelarBridge`}
                          target="_blank"
                        >
                          {" "}
                          Share on X
                        </a>{" "}
                      </div> */}
                    </FTypo>
                  </div>
                  <FTypo
                    color="#FFFFFF"
                    size={12}
                    weight={700}
                    className="f-mt-2 congrates-swap-text"
                  >
                    See transaction details on the{" "}
                    <span
                      style={{ color: "#D9B373" }}
                      className="cursor-pointer"
                      onClick={() => {
                        dispatch(SwapActions.makeAnotherSwap());
                        history.push(`${PATH_DASHBOARD.multiswap.myTrades}`);
                      }}
                    >
                      MY Trades Page
                    </span>
                  </FTypo>
                  <FGrid className="congrates-swap-button f-mt-1">
                    {/* <FItem>
                      <FButton
                        title={"Share on X"}
                        prefix={<img src={xIcon} alt="x icon" />}
                        className="btn-step f-mt-1 f-mb-1 custom-font-size-18 font-700 btn-44-h swap-congrates-add-to-metamask continue-swap-congrates-mobile swap-continue-btn"
                        onClick={`https://twitter.com/intent/post?text=Just%20used%20%23MultiSwap%20by%20%40FerrumNetwork%20to%20swap%20%24${fromInfo?.network?.name}%20on%20%23${fromInfo?.token?.symbol}%20for%20%24${toInfo?.network?.name}%20on%20%23${toInfo?.token.symbol}%20with%20a%20click%20on%20a%20button.%20%0A%0ABlazing%20fast%20swaps%20and%20super%20easy%20to%20use%21%0A%0ATry%20it%20yourself%3A%0Ahttps%3A%2F%2Fmultiswap.ferrumnetwork.io%2F%0A%0A%24FRM%20%23Bridge%20%23CrossChainBridges%20%24RBC%20%23CelarBridge`}
                      />
                    </FItem> */}
                    <a
                      className="f-btn  f-btn-primary f-btn-button   
                        undefined undefined btn-step f-mt-1 f-mb-1 custom-font-size-18 font-700 btn-44-h swap-congrates-continue continue-swap-congrates-mobile swap-continue-btn  btn-step f-mt-1 f-mb-1 custom-font-size-18 font-700 btn-44-h swap-congrates-add-to-metamask continue-swap-congrates-mobile swap-continue-btn white-color text-decoration-none custom-font-size-18"
                      href={`https://twitter.com/intent/post?text=%F0%9F%9A%80%20Just%20used%20%400xMultiSwap%20by%20%40FerrumNetwork%0A%20to%20swap%20%24${fromInfo?.token?.symbol}%20on%20%23${fromInfo?.network?.name}%20for%20%24${toInfo?.token?.symbol}%20on%20%23${toInfo?.network?.name}%20with%20a%20click%20on%20a%20button.%0A%0ABlazing%20fast%20swaps%20and%20super%20easy%20to%20use%21%20%F0%9F%94%A5%0A%0A%F0%9F%91%89Try%20it%20yourself%3A%0Ahttps%3A%2F%2Fswap.multiswap.network%0A%0A%24FRM%20%24SWAPS`}
                      target="_blank"
                    >
                      <span className="f-mr--10">SHARE ON </span>
                      <img src={xIcon} alt="x icon" />
                    </a>
                    <FItem>
                      <FButton
                        title={"CONTINUE"}
                        className="btn-step f-mt-1 f-mb-1 custom-font-size-18 font-700 btn-44-h swap-congrates-continue continue-swap-congrates-mobile swap-continue-btn"
                        onClick={() => {
                          dispatch(SwapActions.makeAnotherSwap());
                          queryParams.set("amount", "");
                          history.push({
                            pathname: "/swap",
                            search: queryParams.toString(),
                          });
                          onClose();
                        }}
                      />
                    </FItem>
                  </FGrid>
                </FItem>
              </div>
            </React.Fragment>
          ) : FailedStatuses.includes(status) ? (
            <React.Fragment>
              <img
                className="ml-9"
                src={iconWarning}
                alt={""}
                style={{ width: 100, height: 100 }}
              />
              <FTypo color="white" size={20} weight={700} className="f-mt-3">
                {SwapAndWithdrawTxStatuses[status]}
              </FTypo>
              <p className="d-flex ai ai-center jc jc-center f-mt-1 custom-font-size-15">
                <span className="f-mr--5" style={{ color: "#88898A" }}>
                  Check Your Source Network Transaction. If Not Found On
                  Explorer Resubmit.
                </span>
              </p>
              <a
                className="custom-font-size-15"
                style={{ color: "#88898A" }}
                href={
                  "https://help.ferrumnetwork.io/en/articles/9053975-swap-failed"
                }
                target={"_blank"}
              >
                Learn More
              </a>
            </React.Fragment>
          ) : null}
        </div>
      </FDialog>
    </div>
  );
};
